import React from "react";
import "./About.scss"

// core components
import DropdownFixedNavbar from "@/components/Navbars/CommonNavbar"
import AboutUsHeader from "@/components/Headers/AboutUsHeader";
import Footer from "@/components/Footers/FooterSocial";
// import Advantages from "./Advantages";
// import AboutOffice from "./AboutOffice";
// import AboutTeam from "./AboutTeam";
import AboutFeatures from "./AboutFeatures";
import WorkWithUs from "./WorkWithUs";


function AboutUs() {

  React.useEffect(() => {
    document.body.classList.add("about-us");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);
  return (
    <div id="about-us">
      <DropdownFixedNavbar />
      <div className="wrapper">
        <AboutUsHeader />
        <div className="section">
          <AboutFeatures />
          {/* <AboutTeam /> */}
          <WorkWithUs />
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default AboutUs;
